import { render, staticRenderFns } from "./polygon.vue?vue&type=template&id=a7f06be8"
import script from "./polygon.vue?vue&type=script&lang=js"
export * from "./polygon.vue?vue&type=script&lang=js"
import style0 from "./polygon.vue?vue&type=style&index=0&id=a7f06be8&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports